import React from 'react';

/**
 * @param {{ label: string, value: React.ReactNode, hint?: string, variant?: 'default'|'highlight' }} props
 */
export default function AdminMetricCard({ label, value, hint, variant = 'default' }) {
  return (
    <div
      className={`admin-hub-kit-metric${variant === 'highlight' ? ' admin-hub-kit-metric--highlight' : ''}`}
    >
      <div className="admin-hub-kit-metric__label">{label}</div>
      <div className="admin-hub-kit-metric__value">{value}</div>
      {hint ? <div className="admin-hub-kit-metric__hint">{hint}</div> : null}
    </div>
  );
}
